import styles from './Avatar.module.css';

interface Props {
  name: string | null;
  hue: number;
  size?: number;
}

/** A coloured initial. Hue is stable per person; saturation stays sun-faded. */
export function Avatar({ name, hue, size = 40 }: Props) {
  const initial = (name?.trim()[0] ?? '?').toUpperCase();
  return (
    <span
      className={styles.avatar}
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        fontSize: size * 0.46,
        background: `radial-gradient(circle at 35% 25%, hsl(${hue} 34% 66%), hsl(${hue} 30% 50%))`,
      }}
    >
      {initial}
    </span>
  );
}
